export default {
  Arquitecta: 'Arquitecta, Helvetica, Arial, sans-serif',
  Proxima: 'Proxima-Nova, Helvetica, Arial, sans-serif'
}
